import { ACTION_TYPES as LocationPickerActions } from '../../LocationPicker';

export const FALLBACK_LATITUDE = 40.7388319;
export const FALLBACK_LONGITUDE = -73.9815337;

const initialState = {
    latitude: FALLBACK_LATITUDE,
    longitude: FALLBACK_LONGITUDE,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LocationPickerActions.UPDATE_LOCATION:
            return {
                ...state,
                latitude: action.location ? action.location.lat : FALLBACK_LATITUDE,
                longitude: action.location ? action.location.lng : FALLBACK_LONGITUDE,
            };
        default:
            return state;
    }
};
